import React, { Component } from 'react';
import { WithKeyboardChange } from '@platform/base';
import { isArrowKeyDown, ViewModel } from '@platform/api';
import classnames from 'classnames';
// import { dateTypes } from '../../utils';

const { createKeyMap, processCursorPointInSide, processCursorPointInTopOrBottom } = WithKeyboardChange;
const { keyByModuleId } = createKeyMap;

let preventDefaultKeys = new Set([13, 38, 40]);

export default function useHotKey(Table) {
    return class HotKeyTable extends Component {
        render() {
            let { store, flex, id, hotKeyWithEnter, pageScope, hotkeyConfig = {} } = this.props,
                { enterDirection } = hotkeyConfig;
            return <div
                className={classnames("table-hotkey-wrapper", { 'flex-container': flex })}
                id={`hot-key-${id}`}
                onKeyDown={event => { // 先去掉capture，否则select本身的快捷键不触发了，有问题再看
                    if (!event.currentTarget.contains(event.target)) {
                        return;
                    }

                    let {
                            getFocusedCell,
                            focusOnCell,
                            setSelectedCell,
                            getStatus,
                            getCheckedKeys,
                            getConfig,
                            // getColumnProps,
                        } = store,
                        focusedCell = getFocusedCell();
                    console.log('keydown', focusedCell);
                    if (focusedCell.rowKey && focusedCell.colKey) {
                        let key = event.keyCode || event.charCode || event.which;
                        let { rowKey, colKey } = focusedCell,
                            // { itemtype } = getColumnProps(colKey),
                            { onCellKeyDown } = getConfig(),
                            functionCall = false,
                            moveResult;
                        //根据class类名判断日期面板是否存在
                        // let datePanelExist = document.querySelector('.picker-panel-body') && !document.querySelector('.wui-dropdown-hidden') ;
                        // let isDateOpen = dateTypes.has(itemtype) && datePanelExist;

                        // textarea 中 ctrl/cmd + enter、alt + enter 用于换行，放行原生换行，不再触发单元格跳转
                        if (
                            key === 13 &&
                            event.target?.localName === 'textarea' &&
                            (event.ctrlKey || event.altKey || event.metaKey)
                        ) {
                            return;
                        }

                        if ([37, 39].includes(key)) {
                            if (!isArrowKeyDown(event, [37, 39])) {return;} // 有shift等特殊键
                            if (event.target.value) {
                                let cursorInStartOrEnd = false;
                                processCursorPointInSide(() => { cursorInStartOrEnd = true; }, event);
                                if (!cursorInStartOrEnd) {return;} // 光标不在开头或者结尾
                            }
                            event.preventDefault();
                        } else if ([38, 40].includes(key) && event.target?.localName === 'textarea') {
                            if (!isArrowKeyDown(event, [38, 40])) {return;} // 有shift等特殊键
                            if (event.target.value) {
                                let cursorInStartOrEnd = false;
                                processCursorPointInTopOrBottom(() => { cursorInStartOrEnd = true; }, event);
                                if (!cursorInStartOrEnd) {return;} // 光标不在开头或者结尾
                            }
                            event.preventDefault();
                        }

                        preventDefaultKeys.has(key) && event.preventDefault();

                        switch (key) {
                            // tab
                            case 9:
                                event.stopPropagation();
                                moveResult = store.moveTo(rowKey, colKey, { right: event.shiftKey ? -1 : 1, loop: false });
                                if (moveResult) {
                                    event.preventDefault();
                                } else {
                                    event.preventDefault();
                                    hotKeyWithEnter({ e: event, moduleId: id, ViewModel });
                                }
                                functionCall = true;
                                break;
                            // enter
                            case 13:
                                event.stopPropagation();
                                moveResult = store.moveTo(rowKey, colKey, { [enterDirection]: event.shiftKey ? -1 : 1, loop: false });
                                if (moveResult) {
                                    event.preventDefault();
                                } else {
                                    hotKeyWithEnter({ e: event, moduleId: id, ViewModel });
                                }
                                functionCall = true;
                                break;
                            // space
                            case 32:
                                if (getStatus() === 'browse') {
                                    event.stopPropagation();
                                    event.preventDefault();
                                    let checkedKeys = getCheckedKeys(),
                                        { checkboxConfig } = this.props,
                                        isChecked;

                                    if (checkedKeys.has(rowKey)) {
                                        checkedKeys.delete(rowKey);
                                        isChecked = false;
                                    } else {
                                        checkedKeys.add(rowKey);
                                        isChecked = true;
                                    }

                                    checkboxConfig?.onCheck?.(rowKey, { isChecked, checkedKeys });
                                    functionCall = true;
                                }
                                break;
                            // left
                            case 37:
                                event.stopPropagation();
                                moveResult = store.moveTo(rowKey, colKey, { right: -1 });
                                functionCall = true;
                                break;
                            // top
                            case 38:
                                event.stopPropagation();
                                if (event.shiftKey) {
                                    // 跳到上一个区域第一个可编辑字段
                                    console.log(keyByModuleId);
                                } else {
                                    moveResult = store.moveTo(rowKey, colKey, { bottom: -1 });
                                }
                                functionCall = true;
                                break;
                            // right
                            case 39:
                                event.stopPropagation();
                                moveResult = store.moveTo(rowKey, colKey, { right: 1 });
                                functionCall = true;
                                break;
                            // bottom
                            case 40:
                                event.stopPropagation();
                                if (event.shiftKey) {
                                    // 跳到下一个区域第一个可编辑字段
                                    console.log(keyByModuleId);
                                } else {
                                    moveResult = store.moveTo(rowKey, colKey, { bottom: 1 });
                                }
                                functionCall = true;
                                break;
                            default:
                                break;
                        }
                        if (moveResult) {
                            setSelectedCell(new Map());
                            focusOnCell(moveResult.rowKey, moveResult.colKey);
                        }
                        if (functionCall && typeof onCellKeyDown === 'function') {
                            let row = store.getRowData(rowKey),
                                col = store.getColumnProps(colKey);
                            onCellKeyDown({ ...pageScope.props, ...pageScope.output }, id, row, row.viewIndex, col.key, col, event, 'table');
                        }
                    }

                }}>
                <Table {...this.props}></Table>
            </div>;
        }
    };
}

useHotKey.displayName = 'useHotKey';
useHotKey.dependence = [];
useHotKey.hooks = function () {
    return {
        copy: content => {
            if (window.isSecureContext) {  
                // navigator方式
                if (navigator?.clipboard?.writeText) { //支持navigator的浏览器 chrome
                    navigator.clipboard.writeText(content).then(function () {
                        // console.log('navigator复制');
                    });
                } else if (window.clipboardData) { //不支持navigator的但支持clipboardData的 IE
                    window.clipboardData.setData('Text', content);
                    // console.log('clipboard复制');
                }
                // TODO Edge
            } else { //假设复制的内容有/r(回车),下面方法粘贴中的内容会自动加上/n,但上面的方式不会加/n
                // 创建text area
                let textArea = document.createElement("textarea");
                textArea.value = content;
                // 使text area不在viewport，同时设置不可见
                textArea.style.position = "absolute";
                textArea.style.opacity = 0;
                textArea.style.left = "-999999px";
                textArea.style.top = "-999999px";
                document.body.appendChild(textArea);
                textArea.focus({ preventScroll: true });
                textArea.select();
                document.execCommand('copy');
                textArea.remove();
            }
        },
    };
};